<template>
  <h1>DepartureList</h1>
</template>

<script>
export default {
  name: "DepartureList"
};
</script>

<style></style>
